export default {
    APP_FULLY_RENDERED: 'appFullyRendered',
    APP_FIRST_PREVIEW: 'appFirstPreview',
};
